module.exports = __webpack_public_path__ + "static/media/cash-for-damaged-car-beenleigh.79d78d59.png";